module.exports = __webpack_public_path__ + "static/media/autoline-alpha.5eff66bc.png";